import ZkUserAllotRole from './src/main'
ZkUserAllotRole.install = function (Vue) {
  Vue.component(ZkUserAllotRole.name, ZkUserAllotRole)
}
export default ZkUserAllotRole



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/userAllotRole/index.js